export default __webpack_public_path__ + "static/media/hardship.af105b74.png";